// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkypeOutlinedSvg from "@ant-design/icons-svg/es/asn/SkypeOutlined";
import AntdIcon from '../components/AntdIcon';

var SkypeOutlined = function SkypeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkypeOutlinedSvg
  }));
};

SkypeOutlined.displayName = 'SkypeOutlined';
export default React.forwardRef(SkypeOutlined);